module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "watchStukw"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.exampaperData.resourceName))]), _vm._v(" "), _c('div', [_c('watchStuHead', {
    attrs: {
      "useInfo": _vm.useInfo,
      "userScore": _vm.userScore,
      "userRank": _vm.userRank
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "watchStuCon"
  }, [_c('div', {
    staticClass: "watchStuConT"
  }, [_c('p', {
    staticClass: "stuConT-l fl"
  }, [_vm._v("要求" + _vm._s(_vm.readText) + _vm._s(_vm.readTimes) + "次；该题分值：" + _vm._s(_vm.exampaperData.workScore) + "分。(实际" + _vm._s(_vm.readText) + _vm._s(_vm.exampaperData.submitCount) + "次)")]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("播放全部音频")]), _c('div', {
    staticClass: "fl"
  }, [_c('theAudio', {
    attrs: {
      "src": null,
      "allUrl": _vm.allUrl,
      "id": 0,
      "playerObj": _vm.playerObj
    },
    on: {
      "playedObj": _vm.playedObj
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "stuSubject"
  }, _vm._l((_vm.exampaperData.workAnswers), function(sub, $index) {
    return _c('li', {
      staticClass: "stuSubCon"
    }, [_c('p', {
      staticClass: "stuSubM"
    }, [_vm._v(_vm._s(_vm.matchCont(sub.answers[0].word)))]), _vm._v(" "), _c('div', {
      staticClass: "stuSubConFoot clearfix"
    }, [_c('div', {
      staticClass: "subConFoot-l fl"
    }, [_c('theAudio', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "src": sub.answers[0].audioUrl,
        "id": sub.versionId,
        "playerObj": _vm.playerObj
      },
      on: {
        "playedObj": _vm.playedObj
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "subConFoot-r fr"
    }, [_c('span', {
      staticClass: "subConSocre"
    }, [_vm._v(_vm._s(sub.score))]), _vm._v(" "), _c('span', [_vm._v("分")])])])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83a18890","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/watchStukw.vue
// module id = 1229
// module chunks = 1